
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promotion",
      function () {
        return require("private-next-pages/promotion/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promotion"])
      });
    }
  